import React from 'react';
import {Link} from 'react-router-dom';
import dayjs from 'dayjs';
import PageHeaderLayout from '../../layout/pageHeaderLayout';
import StandardTable, {StandardColumnsType} from '../../components/StandardTable';
import useAntTable from '../../utils/useAntTable';
import * as api from '../../apis/preDealer';

const statusOptions = [
    {text: '待完善', value: 0},
    {text: '已生成客户', value: 1},
    {text: '已作废', value: 2},
];

const statusNames: Record<number, string> = {0: '待完善', 1: '已生成客户', 2: '已作废'};

function PreDealer() {
    const {tableProps, form, search} = useAntTable(api.getPreDealers, {});
    const columns: StandardColumnsType = [
        {title: '申请编号', dataIndex: 'applicationNo', search: true},
        {title: '客户名称/简称', dataIndex: 'name', search: true},
        {title: '客户简称', dataIndex: 'nameShort'},
        {title: '总经理', dataIndex: 'manager'},
        {title: '总经理电话', dataIndex: 'managerPhone'},
        {title: '销售人员', dataIndex: 'selectedSalesName'},
        {
            title: '状态', dataIndex: 'status',
            render: value => statusNames[value] || '-',
            search: {valueType: 'select', valueEnum: statusOptions},
        },
        {title: '提交时间', dataIndex: 'createTime', render: value => value ? dayjs(value).format('YYYY-MM-DD HH:mm') : '-'},
        {
            title: '操作', dataIndex: 'operations', fixed: 'right',
            render: (_, record: any) => {
                if (record.status === 0) {
                    return <Link to={`/customer/preDealer/detail/${record.id}`}>完善资料</Link>;
                }
                if (record.status === 1 && record.dealerVersionId) {
                    return <Link to={`/customer/dealer/version/${record.dealerVersionId}`}>客户详情</Link>;
                }
                return '-';
            },
        },
    ];

    return (
        <PageHeaderLayout>
            <StandardTable rowKey="id" columns={columns} form={form} search={search}
                           scroll={{x: 'max-content'}} {...tableProps}/>
        </PageHeaderLayout>
    );
}

export default PreDealer;
